'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactScroll = require('react-scroll');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _PlanScorecardCompanyLetter = require('./PlanScorecardCompanyLetter.css');

var _PlanScorecardCompanyLetter2 = _interopRequireDefault(_PlanScorecardCompanyLetter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdobeCompanyLetter = (_dec = (0, _reactCssModules2.default)(_PlanScorecardCompanyLetter2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AdobeCompanyLetter, _Component);

  function AdobeCompanyLetter(props) {
    (0, _classCallCheck3.default)(this, AdobeCompanyLetter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdobeCompanyLetter.__proto__ || (0, _getPrototypeOf2.default)(AdobeCompanyLetter)).call(this, props));

    _this.state = {
      differentPage: _this.props.differentPage || false,
      companyName: 'Adobe',
      companyPath: 'adobe',
      letterDate: 'May 26, 2022',
      addresseeSurname: 'Mr. Narayen',
      addressee: _react2.default.createElement(
        'span',
        null,
        'Shantanu Narayen',
        _react2.default.createElement('br', null),
        'Chief Executive Officer'
      ),
      address: _react2.default.createElement(
        'span',
        null,
        '345 Park Avenue',
        _react2.default.createElement('br', null),
        'San Jose, CA',
        _react2.default.createElement('br', null),
        '95110'
      ),
      aspirationalGoal: 'its aspirational goals of running company operations and digital delivery of product with 100% renewable energy by 2035',
      ESGOptions: 'the Company’s employee retirement plan currently has only one ESG option available for employees who want to invest sustainably. Despite stated social goals, the Adobe employee retirement plan is currently investing in companies profiting from the prison industrial complex.',
      defaultPercent: 'Over 45% of assets'
    };
    return _this;
  }

  (0, _createClass3.default)(AdobeCompanyLetter, [{
    key: 'render',
    value: function render() {
      //
      return _react2.default.createElement(
        'blockquote',
        { styleName: 'company-letter-blockquote' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'May 26, 2022'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            this.state.addressee,
            _react2.default.createElement('br', null),
            this.state.companyName,
            _react2.default.createElement('br', null),
            this.state.address
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Re: ',
            this.state.companyName,
            ' employee retirement plan sustainability scorecard'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Dear ',
          this.state.addresseeSurname,
          ','
        ),
        _react2.default.createElement(
          'p',
          null,
          this.state.companyName,
          ' is known to be a leader on climate change, highlighted by ',
          this.state.aspirationalGoal,
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'However, your company retirement plan directly contradicts all of this hard work on your operations.'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'I am writing to inform you about the recent release of ',
          _react2.default.createElement(
            'i',
            null,
            'As You Sow\u2019s'
          ),
          ' corporate retirement plan sustainability scorecard initiative and would like to extend an offer to meet and discuss our work. Below is a brief overview of the scorecard, where ',
          this.state.companyName,
          ' is among the first companies rated. '
        ),
        _react2.default.createElement(
          'p',
          null,
          'The corporate retirement plan sustainability scorecard initiative will empower the millions of U.S. employees holding trillions in retirement assets to invest their retirement savings sustainably. Many employees across the nation are unaware that their retirement plan investments are invested in climate change, prisons, weapons, and companies that score poorly on gender equality.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'We are using our ',
          _react2.default.createElement(
            _.Link,
            { to: _config2.default.links.aysinvest, title: 'Invest Your Values - As You Sow', xstrong: true },
            'expertise in mutual fund sustainability analysis'
          ),
          ' and our extensive database of ESG-screened companies to rate corporations\u2019 retirement plan investment options. Those investment options have been graded across seven major environmental and social issues, including deforestation, climate, and the prison industrial complex.'
        ),
        this.state.differentPage ? _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              _.Link,
              { to: _config2.default.routes.plans + '/' + this.state.companyPath, title: this.state.companyName + ' retirement plan sustainability scorecard', xstrong: true },
              'The scorecard results for ',
              this.state.companyName,
              '\'s retirement plan'
            ),
            ' directly contradict ',
            this.state.companyName,
            ' leadership on climate change and other issues.'
          )
        ) : _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              _reactScroll.Link,
              { to: 'scores', spy: true, title: this.state.companyName + ' retirement plan sustainability scorecard', smooth: true, offset: -50, duration: 500 },
              _react2.default.createElement(
                'span',
                { styleName: 'scroll-link' },
                'The scorecard results for ',
                this.state.companyName,
                ' retirement plan'
              )
            ),
            ' directly contradict ',
            this.state.companyName,
            ' leadership on climate change and other issues.'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Since 1992, ',
          _react2.default.createElement(
            'i',
            null,
            'As You Sow'
          ),
          ' has had great success helping companies to adopt beneficial policies and practices on a range of environmental, social, and governance issues. The time is ripe for ',
          this.state.companyName,
          ' to show its leadership by aligning its sustainability goals holistically across both operations and its retirement plan. We commend ',
          this.state.companyName,
          ' in its efforts to build a sustainable business for all stakeholders and the planet, including ambitious climate goals and implementing them with action.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'While ',
          this.state.companyName,
          ' has made significant efforts in addressing climate change and social issues across its operations, data obtained from Form 5500 SEC filings, along with information published by the Company for retirement plan participants, demonstrates a lack of alignment between the Company\u2019s sustainability goals and its current retirement investment options offered through the Company\u2019s employee retirement plan. Although ',
          this.state.companyName,
          ' has established its commitment to reducing its climate impact, ',
          this.state.ESGOptions
        ),
        _react2.default.createElement(
          'p',
          null,
          'Critically, the default plan option is not invested sustainably. ',
          this.state.defaultPercent,
          ' invested in the ',
          this.state.companyName,
          ' employee retirement plan are invested in the default option target date funds. Because these funds are not invested sustainably, hundreds of millions of dollars in employee savings are being allocated to fossil fuel companies, deforestation-risk commodity producer/traders, and other sustainability risk sectors.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Most employees assume the default option in their retirement plan is a safe choice. But if climate risk and other sustainability issues are not incorporated into the portfolio composition by the fund manager, employees could be exposed to financial risks from unsustainable investments. Asset managers recognize they have a fiduciary duty to mitigate the systemic risks of climate change: in 2020, ',
          _react2.default.createElement(
            _.Link,
            { to: 'https://www.blackrock.com/corporate/investor-relations/2020-blackrock-client-letter', title: 'Sustainability as BlackRock\u2019s New Standard for Investing', xstrong: true },
            'major asset manager BlackRock announced'
          ),
          ' "We intend to make sustainable funds the standard." '
        ),
        this.state.differentPage ? _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            this.state.companyName,
            '\'s retirement plan is rated Poor on five of seven issue areas. The full results ',
            _react2.default.createElement(
              _.Link,
              { to: _config2.default.routes.plans + '/' + this.state.companyPath, title: this.state.companyName + ' retirement plan sustainability scorecard', xstrong: true },
              'can be found here.'
            )
          )
        ) : _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            this.state.companyName,
            '\'s retirement plan is rated Poor on five of seven issue areas. The full results ',
            _react2.default.createElement(
              _reactScroll.Link,
              { to: 'scores', spy: true, title: this.state.companyName + ' retirement plan sustainability scorecard', smooth: true, offset: -50, duration: 500 },
              _react2.default.createElement(
                'span',
                { styleName: 'scroll-link' },
                'can be found here.'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          this.state.companyName,
          ' has the unique opportunity to become an industry leader and help shift billions of dollars away from climate destruction and into companies that define the new economic paradigm in a safe, just, and sustainable world. We would appreciate the opportunity to meet with you and show you the details of our scorecard.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Thank you for your time and consideration, and we look forward to hearing back from you. '
        ),
        _react2.default.createElement(_.AndrewBeharSignature, null)
      );
    }
  }]);
  return AdobeCompanyLetter;
}(_react.Component), _class2.propTypes = {
  differentPage: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = AdobeCompanyLetter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardCompanyLetter/AdobeCompanyLetter.js
// module id = 1393
// module chunks = 0